<template>
  <div id="addArea" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo catalogoTitle">Agregar Puesto</v-row>
      <v-row class="catalogo catalogoList">
        <v-col cols="12" sm="8" class="py-2">Empresa Pagadora</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select
            name="estructura"
            id="estructura"
            v-model="enterprise"
            @change="obtenerAreasTrabajos()"
          >
            <option disabled value="0">Selecciona empresa</option>
            <option
              v-for="enterprise in enterprises"
              :key="enterprise.id"
              v-bind:value="enterprise.id"
            >
              {{ enterprise.razonSocial }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="nomarea">Área a la que reporta</label>
        </v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="areaRep" id="areaRep" v-model="area">
            <option disabled value="0">Selecciona área</option>
            <option v-for="area in areas" :key="area.id" v-bind:value="area.id">
              {{ area.nombreArea }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">
          <label for="puestoRep">Puesto al que reporta</label>
        </v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="puestoRep" id="puestoRep" v-model="jobr">
            <option disabled value="0">Selecciona puesto</option>
            <option v-for="job in jobs" :key="job.id" v-bind:value="job.id">
              {{ job.nombrePuesto }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Número de posiciones</v-col>
        <v-col cols="12" sm="4" class="py-2 selectGris">
          <select name="posicion" id="posicion" v-model="posicion">
            <option disabled value="0">Selecciona nivel jerárquico</option>
            <option
              v-for="level in niveles"
              :key="level.id"
              v-bind:value="level.id"
            >
              {{ level.name }}
            </option>
          </select>
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Nombre del Puesto</v-col>
        <v-col cols="12" sm="4" class="py-2 inputEnterprise">
          <input
            type="text"
            id="nomPuesto"
            name="nomPuesto"
            maxlength="30"
            placeholder="Obligatorio"
            autocomplete="false"
            v-model="job"
            required
            @keypress="alfaNumerico($event)"
            style="
              width: 90% !important;
              margin-left: 0;
              padding-left: 3% !important;
            "
          />
        </v-col>
        <v-col cols="12" sm="8" class="py-2">Clave del Puesto</v-col>
        <v-col cols="12" sm="4" class="py-2 inputEnterprise">
          <input
            type="text"
            id="keyPuesto"
            name="keyPuesto"
            maxlength="30"
            placeholder="Obligatorio"
            autocomplete="false"
            v-model="key"
            required
            @keypress="alfaNumerico($event)"
            style="
              width: 90% !important;
              margin-left: 0;
              padding-left: 3% !important;
            "
          />
        </v-col>
        <v-col>
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
      <v-col></v-col>
    </v-container>

    <!--Error-->
    <v-dialog v-model="error" width="380">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ titulo }}</span>
        </v-card-title>
        <v-card-text>
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul style>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            ¿Esta seguro de almacenar el tipo de puesto?
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="
              cancel();
              advice = false;
            "
            >Cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardarPuesto()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Puesto</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-sm-center text-md-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      show: false,
      stepn: "11-N",
      error: false,
      errors: [],
      niveles: [],
      respuesta: "",
      titulo: "",
      nivel: 0,
      carga: 0,
      nombreCorto: "",
      nombreArchivo: "",
      enterprise: 0,
      enterprises: [],
      areas: [],
      area: 0,
      jobs: [],
      jobr: 0,
      job: "",
      key: "",
      advice: false,
      confirmation: false,
      posicion: 0,
    };
  },
  methods: {
    nombre() {
      localStorage.stepn = this.stepn;
    },
    regresar() {
      this.enterprise = 0;
      this.jobr = 0;
      this.key = "";
      this.job = "";
      this.area = 0;
      this.posicion = 0;
      this.stepn = "14-N";
      this.nombre();
      this.$router.push("/jobList");
    },

    validacion() {
      this.errors = [];
      if (this.enterprise == 0) {
        this.errors.push("Se debe especificar la empresa.");
      }
      if (this.area == 0 || this.area == " ") {
        this.errors.push("Se debe especificar el Área a la que reporta.");
      }
      if (this.jobr == 0 || this.jobr == " ") {
        this.errors.push("Se debe especificar el Puesto al que reporta.");
      }
      if (this.job == "" || this.job == " ") {
        this.errors.push("Se debe especificar el Nombre de Puesto.");
      }
      if (this.key == "" || this.key == " ") {
        this.errors.push("Se debe especificar la clave de Puesto.");
      }
      if (this.posicion == 0) {
        this.errors.push("Se debe especificar la posición Puesto.");
      }
      if (this.errors.length == 0) {
        this.advice = true;
      } else {
        this.titulo = "Alta de Puesto";
        this.error = true;
      }
    },

    guardarPuesto() {
      this.advice = false;
      this.show = true;
      axios
        .post(Server + "/puestos", {
          EmpresaId: this.enterprise,
          AreaReportaId: this.area,
          PuestoReportaId: this.jobr,
          NumeroPosiciones: parseInt(this.posicion),
          NombrePuesto: this.job,
          Clave: this.key,
        })
        .then((response) => {
          this.enterprise = "";
          this.area = 0;
          this.jobr = 0;
          this.posicion = 0;
          this.job = "";
          this.key = "";
          this.respuesta = "El Puesto fue guardado con éxito";
          this.show = false;
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.area = 0;
          this.jobr = 0;
          this.posicion = 0;
          this.job = "";
          this.key = "";
          this.respuesta = "El Puesto no fue almacenado";
          this.confirmation = true;
        });
    },
    previewFiles(event) {
      this.errors = [];
      console.log(event);
      this.nombreArchivo = event.target.files[0].name;
      this.nombreArchivo.toLowerCase();
      var regex = new RegExp("(.*?).(xlsx|xls)$");

      if (!regex.test(this.nombreArchivo)) {
        this.nombreArchivo = "";
        this.titulo = "Archivo inválido";
        this.errors.push(
          "No se permite el archivo que ingreso favor de ingresar archivo con layout predeterminado."
        );
        this.error = true;
      } else {
        console.log("archivo bn");
        var selectedFile = event.target.files[0];
        //this.formData.append("file", selectedFile, selectedFile.name);
      }
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.enterprises = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    obtenerAreasTrabajos() {
      this.area = 0;
      this.jobr = 0;
      this.posicion = 0;
      this.areas = [];
      this.show = true;
      axios
        .get(Server + "/areas")
        .then((response) => {
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            if (value.empresaId == this.enterprise) {
              this.areas.push({
                id: value.id,
                nombreArea: value.nombreArea,
              });
            }
          });
          this.show = false;
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });

      this.jobs = [];
      this.jobs.push({
        id: 0,
        nombrePuesto: "Ninguno",
      });
      this.show = true;
      axios
        .get(Server + "/puestos")
        .then((response) => {
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            if (value.empresaId == this.enterprise) {
              this.jobs.push({
                id: value.id,
                nombrePuesto: value.nombrePuesto,
              });
            }
          });
          this.show = false;
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
    },
    cancel() {
      this.enterprise = 0;
      this.job = "";
      this.key = "";
      this.jobr = 0;
      this.area = 0;
      this.posicion = 0;
    },

    aux() {
      this.confirmation = false;
      this.$router.push("/jobList");
    },
  },
  created() {
    this.nombre();
    this.listar();
    for (let index = 1; index <= 99; index++) {
      this.niveles.push({
        id: index,
        name: index.toString(),
      });
    }
  },
};
</script>